import { getApp, getApps, initializeApp } from 'firebase/app'
import { firebaseClientInitConfig } from './config'

const appClient = !getApps().length
  ? initializeApp({ ...firebaseClientInitConfig })
  : getApp()

export default appClient
